/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetSendLimitByIdDto } from '../models/custom-result-of-get-send-limit-by-id-dto';
import { CustomResultOfPaginatedListOfGetAllSendLimitsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-all-send-limits-with-pagination-dto';
import { CustomResultOfPaginatedListOfGetSendLimitsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-send-limits-with-pagination-dto';
import { sendLimitsCreateGet } from '../fn/send-limits/send-limits-create-get';
import { SendLimitsCreateGet$Params } from '../fn/send-limits/send-limits-create-get';
import { sendLimitsCreatePost } from '../fn/send-limits/send-limits-create-post';
import { SendLimitsCreatePost$Params } from '../fn/send-limits/send-limits-create-post';
import { sendLimitsDelete } from '../fn/send-limits/send-limits-delete';
import { SendLimitsDelete$Params } from '../fn/send-limits/send-limits-delete';
import { sendLimitsGetAllSendLimitWithPagination } from '../fn/send-limits/send-limits-get-all-send-limit-with-pagination';
import { SendLimitsGetAllSendLimitWithPagination$Params } from '../fn/send-limits/send-limits-get-all-send-limit-with-pagination';
import { sendLimitsGetSendLimitAudits } from '../fn/send-limits/send-limits-get-send-limit-audits';
import { SendLimitsGetSendLimitAudits$Params } from '../fn/send-limits/send-limits-get-send-limit-audits';
import { sendLimitsGetSendLimitWithPagination } from '../fn/send-limits/send-limits-get-send-limit-with-pagination';
import { SendLimitsGetSendLimitWithPagination$Params } from '../fn/send-limits/send-limits-get-send-limit-with-pagination';
import { sendLimitsUpdateGet } from '../fn/send-limits/send-limits-update-get';
import { SendLimitsUpdateGet$Params } from '../fn/send-limits/send-limits-update-get';
import { sendLimitsUpdatePut } from '../fn/send-limits/send-limits-update-put';
import { SendLimitsUpdatePut$Params } from '../fn/send-limits/send-limits-update-put';

@Injectable({ providedIn: 'root' })
export class SendLimitsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sendLimitsCreateGet()` */
  static readonly SendLimitsCreateGetPath = '/SendLimits/Create';

  /**
   * Create Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendLimitsCreateGet$Response(params?: SendLimitsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return sendLimitsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendLimitsCreateGet(params?: SendLimitsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.sendLimitsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `sendLimitsCreatePost()` */
  static readonly SendLimitsCreatePostPath = '/SendLimits/Create';

  /**
   * Create Send limit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsCreatePost$Response(params: SendLimitsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return sendLimitsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Send limit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsCreatePost(params: SendLimitsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.sendLimitsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `sendLimitsUpdateGet()` */
  static readonly SendLimitsUpdateGetPath = '/SendLimits/Update';

  /**
   * Get Send Limit By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendLimitsUpdateGet$Response(params?: SendLimitsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetSendLimitByIdDto>> {
    return sendLimitsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Send Limit By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendLimitsUpdateGet(params?: SendLimitsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetSendLimitByIdDto> {
    return this.sendLimitsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetSendLimitByIdDto>): CustomResultOfGetSendLimitByIdDto => r.body)
    );
  }

  /** Path part for operation `sendLimitsUpdatePut()` */
  static readonly SendLimitsUpdatePutPath = '/SendLimits/Update';

  /**
   * Update Send limit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsUpdatePut$Response(params: SendLimitsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return sendLimitsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Send limit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsUpdatePut(params: SendLimitsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.sendLimitsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `sendLimitsDelete()` */
  static readonly SendLimitsDeletePath = '/SendLimits/Delete';

  /**
   * Delete Send limit.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsDelete$Response(params: SendLimitsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return sendLimitsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Send limit.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsDelete(params: SendLimitsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.sendLimitsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `sendLimitsGetSendLimitWithPagination()` */
  static readonly SendLimitsGetSendLimitWithPaginationPath = '/SendLimits/GetSendLimitWithPagination';

  /**
   * Get Send Limit With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsGetSendLimitWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsGetSendLimitWithPagination$Response(params: SendLimitsGetSendLimitWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetSendLimitsWithPaginationDto>> {
    return sendLimitsGetSendLimitWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Send Limit With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsGetSendLimitWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsGetSendLimitWithPagination(params: SendLimitsGetSendLimitWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetSendLimitsWithPaginationDto> {
    return this.sendLimitsGetSendLimitWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetSendLimitsWithPaginationDto>): CustomResultOfPaginatedListOfGetSendLimitsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `sendLimitsGetAllSendLimitWithPagination()` */
  static readonly SendLimitsGetAllSendLimitWithPaginationPath = '/SendLimits/GetAllSendLimitWithPagination';

  /**
   * دریافت لیست همه محدودیت های ارسال (سازمان فعلی و همه زیرمجموعه ها) با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsGetAllSendLimitWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsGetAllSendLimitWithPagination$Response(params: SendLimitsGetAllSendLimitWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetAllSendLimitsWithPaginationDto>> {
    return sendLimitsGetAllSendLimitWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست همه محدودیت های ارسال (سازمان فعلی و همه زیرمجموعه ها) با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsGetAllSendLimitWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsGetAllSendLimitWithPagination(params: SendLimitsGetAllSendLimitWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetAllSendLimitsWithPaginationDto> {
    return this.sendLimitsGetAllSendLimitWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetAllSendLimitsWithPaginationDto>): CustomResultOfPaginatedListOfGetAllSendLimitsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `sendLimitsGetSendLimitAudits()` */
  static readonly SendLimitsGetSendLimitAuditsPath = '/SendLimits/GetSendLimitAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendLimitsGetSendLimitAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsGetSendLimitAudits$Response(params: SendLimitsGetSendLimitAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return sendLimitsGetSendLimitAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendLimitsGetSendLimitAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendLimitsGetSendLimitAudits(params: SendLimitsGetSendLimitAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.sendLimitsGetSendLimitAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

}
